import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import type { IOrderContact } from '~/types/order/models'
import type { TEntityId } from '~/types/models'
import {
  getContactListData,
  _getCDataById,
} from '~/api/msw/api/contacts/mockData'

const orderContactListData = undefined as unknown as IOrderContact[]

export const getOrderContactListData = getListDataFunctionFactory<
  IOrderContact[]
>({
  listData: orderContactListData,
  storageKey: 'ordercontacts',
  getStartingListData: getStartingOportunityContactListData,
})

export async function getOrderContactDataById(id: string) {
  const list = await getOrderContactListData()
  if (!list) {
    throw new Error(`getOrderContactListData returned undefined/null`)
  }
  return list.find((oc: IOrderContact) => oc.id === id)
}

export async function getOrderContactListDataByOrderId(
  id: TEntityId
): Promise<IOrderContact[]> {
  const list: IOrderContact[] = await getOrderContactListData()
  if (!list) {
    throw new Error(`getOrderContactListData returned undefined/null`)
  }
  const contacts = list.filter((oc) => oc.order.id === id) ?? []
  return contacts
}

async function getStartingOportunityContactListData(): Promise<
  IOrderContact[]
> {
  const cList = await getContactListData()
  const mo0001 = { id: 'XXORD0001', label: 'DIA - All Locations' }
  return [
    {
      id: 'XXORDC0001',
      hrid: 'ORDC0001',
      order: mo0001,
      contact: _getCDataById('XXCCT0001', cList)!,
      splitFraction: 0.1,
      status: {
        id: 2,
        label: 'Active',
      },
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXORDC0002',
      hrid: 'ORDC0002',
      order: mo0001,
      contact: _getCDataById('XXSCT0002', cList)!,
      splitFraction: null,
      status: {
        id: 2,
        label: 'Active',
      },
      version: '1',
      canBeDeleted: true,
    },
  ]
}
